/**
 * Auth module public API
 *
 * This module completely encapsulates Firebase platform differences.
 * The rest of the codebase should only import from this module
 * and never directly import Firebase libraries.
 */

export { AuthProvider, useAuth } from "./AuthContext";
export { AuthGate } from "./AuthGate";
export type { AuthContextType } from "./types";
